import { createGate } from 'effector-react';
import type { NavigateFunction, NavigateOptions } from 'react-router-dom';

export const navigateEf = createGate<NavigateFunction>('navigate');

export function navigateForEffect(path: string, options?: NavigateOptions) {
  const navigate = navigateEf?.state?.getState?.();
  if(typeof navigate !== 'function') return;

  navigate?.(path, options);
}
